import React from 'react';
import Asterisk from './Asterisk';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DatePicker from 'react-datepicker';
import cx from 'classnames';

/**
 * @typedef {object} CustomDatePickerOwnProps
 * @property {string} [title]
 * @property {boolean} [showAsterisk]
 * @property {string} [description]
 * @property {Date} [selectedDate]
 * @property {(date: Date | [Date, Date] | Date[] | null) => void} [setSelectedDate]
 * @property {boolean} [hasDateError]
 */

/**
 * @typedef {CustomDatePickerOwnProps & React.ComponentProps<typeof DatePicker>} CustomDatePickerProps
 */

/**
 * @param {CustomDatePickerProps} props
 */
const CustomDatePicker = props => {
  const {
    title,
    description,
    setSelectedDate,
    selectedDate,
    showAsterisk = true,
    hasDateError = false,
    disabled = false,
    dateFormat = 'yyyy-MM-dd',
    ...otherProps
  } = props;

  const handleKeyDown = e => {
    e.preventDefault();
  };

  return (
    <div>
      {title && (
        <>
          <p className='bold'>
            {title}
            {showAsterisk && <Asterisk />}
          </p>
        </>
      )}
      {description && <p>{description}</p>}
      <div
        className={cx('date-picker-wrapper', { 'date-error': hasDateError })}
        data-testid='date-picker-wrapper'>
        <DatePicker
          {...otherProps}
          closeOnScroll={true}
          placeholderText='Select date'
          selected={selectedDate}
          dateFormat={dateFormat}
          onKeyDown={handleKeyDown}
          onChange={setSelectedDate}
          disabled={disabled}
        />
        <CalendarTodayIcon />
      </div>
    </div>
  );
};

export default CustomDatePicker;
